<!--
    Para ocultar el button pasar atributo hidden al componente.
    Para deshabilitar el button pasar atributo disabled al componente.
-->

<template>
  <button
    :id="id"
    :class="variant"
    :data-backdrop="dataBackdrop"
    :data-target="dataTarget"
    :data-toggle="dataToggle"
    :style="{ 'min-width': minWidth }"
    :type="type"
    @click.self="click"
  >
    <i v-if="i" class="mr-2" :class="i + ' ' + classIcon" @click.self="click" />

    <slot>{{ text }}</slot>
    <i v-if="iright" class="mr-2" :class="iright" />
  </button>
</template>
<style lang="scss" scoped>
@import '../../shared/scss/config/colors.scss';

button {
  color: map-get($colors, 'gray-7');
  white-space: normal !important;
  background-color: map-get($colors, 'white');
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  text-align: center;
  border-radius: 4px;
  border: 1px solid map-get($colors, 'gray-7');
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
}

.success {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'green');
  border-color: map-get($colors, 'green');
}

.outline-success {
  color: map-get($colors, 'green');
  background-color: transparent;
  border-color: map-get($colors, 'green');
  outline: none;
}

.outline-success:hover {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'green');
}

.danger {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'red');
  border-color: map-get($colors, 'red');
}

.outline-danger,
.outline-danger:active {
  color: map-get($colors, 'red');
  background-color: map-get($colors, 'white');
  border-color: map-get($colors, 'red');
  outline: none !important;
}

.outline-danger:hover {
  background-color: map-get($colors, 'red');
  color: map-get($colors, 'white');
}

.warning {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'yellow-dark');
  border-color: map-get($colors, 'yellow-dark');
}

.outline-warning {
  color: map-get($colors, 'yellow-dark');
  background-color: map-get($colors, 'white');
  border-color: map-get($colors, 'yellow-dark');
}

.dark {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'gray-7');
  border-color: map-get($colors, 'gray-7');
}

.outline-dark {
  color: map-get($colors, 'gray-7');
  background-color: map-get($colors, 'white');
  border-color: map-get($colors, 'gray-7');
}
.success:link,
.success:visited,
.success:hover,
.success:active {
  color: map-get($colors, 'white');
  text-decoration: none;
  background-color: map-get($colors, 'green-dark');
  border: 1px solid map-get($colors, 'green-dark');
}
.success.focus,
.success:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}
.success:disabled {
  color: map-get($colors, 'white');
  background-color: map-get($colors, 'gray-10');
  border-color: map-get($colors, 'gray-10');
  cursor: default;
}
.danger {
  font: Bold 16px/23px Lato;
}
/* This property get to be used when the component is using an icon without text and does not need a right space or left space */
.no-padding {
  padding-right: 0px !important;
}

.orange {
  background-color: map-get($colors, 'orange');
  color: map-get($colors, 'white');
  border-color: map-get($colors, 'orange');
}

.orange:focus {
  outline: none;
}

.transparent {
  color: #3f5b60;
  background-color: map-get($colors, 'gray-1');
  border-color: map-get($colors, 'gray-1');
}

.muted {
  color: map-get($colors, 'secondary-5');
  border-color: map-get($colors, 'secondary-5');
}

.transparent:focus {
  outline: none;
}
</style>
<script>
export default {
  // i: Icono del button a izquierda.
  // iright: Icono del button a derecha.
  // variant: Clase css.
  //Para modal: dataTarget = data-target
  //Para modal: dataToggle = data-toggle
  //Para modal: dataBackdrop = data-backdrop
  name: 'ActionButton',
  meta: {
    description: 'Componente común de acciones personalizadas para botones',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    id: {
      type: String,
      default: '',
      meta: {
        description: 'Id del Componente ActionButton',
        example: 'IdActionButton',
      },
    },
    variant: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para definir estilos',
        example: 'outline-danger',
      },
    },
    type: {
      type: String,
      default: 'button',
      meta: {
        description: 'Especifica la naturaleza del componente',
        example: 'button',
      },
    },
    text: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para el texto',
        example: 'Texto requerido',
      },
    },
    classIcon: {
      type: String,
      default: '',
      meta: {
        description: 'Estilos para el icono',
        example: 'Texto requerido',
      },
    },
    i: {
      type: String,
      default: '',
      meta: {
        description: 'Icono del botón a la izquierda.',
        example: 'Texto requerido',
      },
    },
    iright: {
      type: String,
      default: '',
      meta: {
        description: 'Icono del botón a la derecha',
        example: 'Texto requerido',
      },
    },
    dataTarget: {
      type: String,
      default: '',
      meta: {
        description: 'Apunta a la identificación del modal',
        example: 'Texto requerido',
      },
    },
    dataToggle: {
      type: String,
      default: '',
      meta: {
        description: 'Abre la ventana modal',
        example: 'Texto requerido',
      },
    },
    dataBackdrop: {
      type: String,
      default: '',
      meta: {
        description:
          'Especifica si el modal debe tener una superposición oscura',
        example: 'Texto requerido',
      },
    },
    minWidth: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>
